import Vue from 'vue';
import VueRouter from 'vue-router';
import Dmca from '../views/Dmca.vue';
import Embed from '../views/Embed.vue';
import Gdpr from '../views/Gdpr.vue';
import GdprDeletion from '../views/GdprDeletion.vue';
import Home from '../views/Home.vue';
import Sweeps from '../views/Sweeps.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/embed',
    name: 'Embed',
    component: Embed,
  },
  {
    path: '/gdpr',
    name: 'Gdpr',
    component: Gdpr,
  },
  {
    path: '/gdpr/deletion',
    name: 'GdprDeletion',
    component: GdprDeletion,
  },
  {
    path: '/dmca',
    name: 'Dmca',
    component: Dmca,
  },
  {
    path: '/sweeps',
    name: 'Sweeps',
    component: Sweeps,
  },
];

const router = new VueRouter({
  routes,
});

export default router;
